export default {
  init() {
    const className = 'key-features-spotlight';
    const classNameActive = 'active';
    const btns = document.querySelectorAll('.' + className + '__picture-btn');
    let isOpen = false;

    function closePopup(activeBtn) {
      const popupId = activeBtn.getAttribute('data-popup');
      activeBtn.classList.remove(classNameActive);

      const popup = document.getElementById(popupId);
      popup.classList.remove(classNameActive);
      activeBtn.closest('.'+ className).classList.remove(className + '--active')
      isOpen = false;
    }

    function activePopup(e){
      e.stopPropagation();
      const btn = this;
      const popupId = btn.getAttribute('data-popup');
      const activeBtn =  document.querySelector('.' + className + '__picture-btn.active');

      if (activeBtn) closePopup(activeBtn);

      if (popupId) {
        const popup = document.getElementById(popupId);
        this.classList.toggle(classNameActive);
        popup.classList.toggle(classNameActive);
        this.closest('.'+ className).classList.toggle(className + '--active')
        isOpen = true;
      }
    }

    btns.forEach(btn => btn.addEventListener('click', activePopup))

    document.body.addEventListener('click', (e) => {
      const activeBtn =  document.querySelector('.' + className + '__picture-btn.active');

      if((!e.target.closest('.' + className + '__picture-btn') || !e.target.classList.contains(classNameActive)) && activeBtn) {
        closePopup(activeBtn);
      }
    })

    window.addEventListener('resize', (e) => {
      if (!isOpen && e.target.outerWidth <= 1024) {
        btns[0].click();
      }
    });

    window.addEventListener('load', () => {
      if (!isOpen && document.body.clientWidth <= 1024) {
        btns[0].click();
      }
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/components/key-features-spotlight.js